import Utils from "./utils.class";
const { jQuery: $ } = window;

export default class Trustarc {

    #events = {
        consent: {
            functional: "kmdg_trustarc_functional_consent",
            advertising: "kmdg_trustarc_advertising_consent",
        },
        denied: {
            functional: "kmdg_trustarc_no_functional_consent",
            advertising: "kmdg_trustarc_no_advertising_consent",
        }
    }

    constructor($body) {

        $(window).on(this.events.consent.functional, function() {
            // Its safe to use any scripts that rely on functional cookies here. This can fire multiple times.
            Utils.log("Have trustarc functional consent");

            $body.removeClass("js__consent--no-functional");
            $body.removeClass("js__consent--loading");
            $body.addClass("js__consent--functional");
        });

        $(window).on(this.events.consent.advertising, function() {
            // Its safe to use any scripts that rely on advertising cookies here. This can fire multiple times.
            Utils.log("Have trustarc advertising consent");

            $body.removeClass("js__consent--no-advertising");
            $body.removeClass("js__consent--loading");
            $body.addClass("js__consent--advertising");
        });

        $(window).on(this.events.denied.advertising, function() {
            // Fired when revoking advertising consent. This can fire multiple times.
            Utils.log("No trustarc advertising consent");

            $body.removeClass("js__consent--advertising");
            $body.removeClass("js__consent--loading");
            $body.addClass("js__consent--no-advertising");
        });

        $(window).on(this.events.denied.functional, function() {
            // Fired when revoking functional consent. This can fire multiple times
            Utils.log("No trustarc functional consent");

            $body.removeClass("js__consent--functional");
            $body.removeClass("js__consent--loading");
            $body.addClass("js__consent--no-functional");
        });

        $(".js--open-trustarc").on('click', function () {
            // Redirects a click on our custom button to the actual cookie link (since that seems to be the only way to open the popup)
            $("#teconsent a").trigger('click');
        });
    }

    get events() {
        return this.#events;
    }
}